import React, { useContext } from 'react';
import Typography from '@/components/atoms/typography';
import Link from '@/components/atoms/link';
import { HeaderContext } from '../context';

const OrdersLink = () => {
  const { ordersLink, ordersLinkLabel } = useContext(HeaderContext);

  return (
    <Link
      href={ordersLink.href ?? '/'}
      className="flex items-center justify-center gap-2"
      underline={false}
      underlineOnHover={false}
    >
      <Typography classStyle="h6" className="uppercase">
        {ordersLinkLabel}
      </Typography>
    </Link>
  );
};

export default OrdersLink;
